import { render } from "./Topics.vue?vue&type=template&id=ac8480d0&scoped=true"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"

import "./Topics.vue?vue&type=style&index=0&id=ac8480d0&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac8480d0"]])

export default __exports__